// extracted by mini-css-extract-plugin
module.exports = {"address__button":"AddressBookList_address__button__2CGJF","address__table":"AddressBookList_address__table__zAYNq"};